import { Box, xcss } from '@atlaskit/primitives';
import { getGridTemplateColumns } from '@databases/frontend/table-columns';
import { Database } from '@databases/types/database';
import { HALF_ROW_SELECT_BUTTON_WIDTH } from '@databases/utils/constants';
import { viewHasCalculations } from '@databases/utils/database/utils';
import useView from '@databases/views/useView';
import React, { FunctionComponent } from 'react';

import QuickCalculationsSelect from './QuickCalculationSelect';

interface QuickCalculationsRowProps {
  columnWidths: (number | undefined)[];
  database: Database;
  containerWidth: number;
  canEditContent: boolean;
}

const getQuickCalculationSelectStyles = (width: number | undefined) => {
  return xcss({
    padding: 'space.0',
    width: width !== undefined ? `${width}px` : '',
  });
};

const QuickCalculationsRow: FunctionComponent<QuickCalculationsRowProps> = ({
  columnWidths,
  database,
  canEditContent,
}) => {
  const { view } = useView();

  // if the view has no calculations and the users can't edit the content, the
  // row would just be empty space. in this case, we should hide this empty space.
  if (!viewHasCalculations(view) && !canEditContent) {
    return null;
  }

  return (
    <tr
      style={{
        display: 'grid',
        gridTemplateColumns: getGridTemplateColumns(columnWidths),
        marginLeft: `${HALF_ROW_SELECT_BUTTON_WIDTH}px`,
      }}
    >
      {database.fields.map((fieldId) => {
        const widthIndex = database.fields.indexOf(fieldId);
        const isFirstField = database.fields.indexOf(fieldId) === 0;

        return (
          <Box
            as="td"
            key={fieldId}
            xcss={getQuickCalculationSelectStyles(columnWidths[widthIndex])}
          >
            <QuickCalculationsSelect
              fieldId={fieldId}
              database={database}
              width={columnWidths[widthIndex]}
              canEditContent={canEditContent}
              isFirstField={isFirstField}
            />
          </Box>
        );
      })}
    </tr>
  );
};

export default QuickCalculationsRow;
